import { type ComponentProps, useContext } from 'react'
import { twMerge } from 'tailwind-merge'
import { CellContext } from './context'

interface CellTitleProps extends ComponentProps<'h3'> {}

function CellTitle({ className, children, ...props }: CellTitleProps) {
  const context = useContext(CellContext)
  const size = context?.size

  return (
    <div
      data-slot="cell-title"
      className={twMerge(
        'text-foreground-secondary group-hover/cell:text-foreground line-clamp-3 min-w-0 text-sm font-medium leading-normal',
        size === 'compact' && 'line-clamp-1',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export { CellTitle }
